import React, { Component } from 'react';
import SearchTitle from './components/search.title';
import SearchFilterByCategories from './components/search.filter-by-categories';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../store/actions';
import { Link, withRouter } from 'react-router-dom';
import { API, CURRENCY } from '../../constants';
import { formatMoney } from '../../services';
import Pagination from 'rc-pagination';
import _ from 'lodash';
import { queryStringToJSON as qs } from '../../utils/'

class SearchMain extends Component {

    constructor(props) {
        super(props)

        this.state = {
            listResultSearch: props.searchData,
            totalItems: props.totalItems,
            rowsPerPage: 12,
            currentPage: 1
        }
    }

    onChange = currentPage => {
        this.setState({ currentPage });
        window.scrollTo(0, 0);
    };

    filterByCategory = (e, name) => {
        e.preventDefault();
        const { history, keyword, basenameURL } = this.props;
        const url = `${basenameURL}/search?keyword=${keyword}${name !== "ALL" ? `&category=${encodeURI(name)}` : ``}`;
        history.replace(url);
    }

    componentDidMount() {
        if (this.props.searchData) {
            this.setState({
                listResultSearch: this.props.searchData,
                totalItems: this.props.searchData.length
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (!_.isEqual(prevProps.location.search, this.props.location.search)) {
            const { location, searchData } = this.props;
            const newListResultSearch = qs(location.search).hasOwnProperty("category")
                ? searchData.filter(item =>
                    item.categories.some(mc => mc === qs(location.search).category)
                )
                : searchData;
            this.setState({
                listResultSearch: newListResultSearch,
                totalItems: newListResultSearch.length,
                currentPage: 1
            });
        }
    }

    noItemShow = () => {
        const {
            wording,
            currentLanguage,
            navbarCategory,
            basenameURL
        } = this.props;

        return (
            <div className='row text-center'>
                <div className='col-md-10 col-md-offset-1'>
                    <div className='icon-warpper'>
                        <img src='/assets/img/sf/not-found.png' alt='not-found.png' />
                    </div>
                    <h1 className='uppercase'>{wording.unableItem.bodyMessage}</h1>
                    <p className='white'>
                        {wording.unableItem.urlMessage1}{' '}
                        <Link to={`${basenameURL}`}>
                            {currentLanguage === 'TH'
                                ? navbarCategory[0].categoryNameTh
                                : navbarCategory[0].categoryNameEn}
                        </Link>
                    </p>
                </div>
            </div>
        );
    }

    render() {
        const {
            searchText,
            history,
            wording,
            basenameURL
        } = this.props;

        const {
            listResultSearch,
            currentPage,
            rowsPerPage,
            totalItems,
        } = this.state;

        return (
            <div className='main-wrapper shop oh'>
                <SearchTitle searchText={searchText} />
                {listResultSearch && listResultSearch.length === 0 && (
                    <section className='section-wrap pt-70 pb-40 catalogue'>
                        <div className='container relative'>
                            <div className='row'>
                                <div className='col-md-12 mb-50'>
                                    <div className='shop-catalogue grid-view'>
                                        {this.noItemShow()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                )}
                {listResultSearch && listResultSearch.length !== 0 && (
                    <>
                        <section className='section-wrap pt-70 pb-40 catalogue'>
                            <div className='container relative'>
                                <div className='row'>
                                    <aside className='col-md-3 sidebar'>
                                        <SearchFilterByCategories filterByCategory={(e, name) => this.filterByCategory(e, name)} />
                                    </aside>
                                    <div className='col-md-9 catalogue-col right mb-50'>
                                        <div className='shop-catalogue grid-view'>
                                            {/* className="shop-catalogue grid-view left" */}
                                            <div className='row items-grid'>
                                                {listResultSearch.length > 0 ? listResultSearch
                                                    .slice(
                                                        (currentPage - 1) * rowsPerPage,
                                                        (currentPage - 1) * rowsPerPage + rowsPerPage
                                                    )
                                                    .map(item => {
                                                        return (
                                                            <div
                                                                key={item.id}
                                                                className='col-md-4 col-xs-6 product product-grid'>
                                                                <div className='product-item mb-20'>
                                                                    <div className='product-img hover-1'>
                                                                        <div style={{ cursor: "pointer" }}>
                                                                            <img
                                                                                src={`${API.PRODUCT_IMG_URL}${item.img}`}
                                                                                alt={item.img}
                                                                            />
                                                                            <img
                                                                                src={`${API.PRODUCT_IMG_URL}${item.img}`}
                                                                                alt={item.img}
                                                                                className='back-img'
                                                                            />
                                                                        </div>

                                                                        {item.overTag && (
                                                                            <span className='sold-out valign'>
                                                                                {
                                                                                    wording.homePage.newArrivals
                                                                                        .outOfStock
                                                                                }
                                                                            </span>
                                                                        )}

                                                                        {
                                                                            item.tag && (
                                                                                <div className='product-label label-left'>
                                                                                    <span
                                                                                        className={
                                                                                            item.tag === 'SALE'
                                                                                                ? 'sale'
                                                                                                : item.tag === 'HOT'
                                                                                                    ? 'hot'
                                                                                                    : null
                                                                                        }>
                                                                                        {item.tag}xxx
                                                                                    </span>
                                                                                </div>
                                                                            )
                                                                        }
                                                                        {
                                                                            item.promotionName && (
                                                                                <div className='product-label label-right'>
                                                                                    <span className='pro'>
                                                                                        {item.promotionName}
                                                                                    </span>
                                                                                </div>
                                                                            )
                                                                        }

                                                                        <div
                                                                            className='hover-overlay pointer'
                                                                            onClick={() =>
                                                                                history.push(
                                                                                    `${basenameURL}/product/${item.name.replace(
                                                                                        ' ',
                                                                                        '-'
                                                                                    )}`
                                                                                )
                                                                            }
                                                                        />
                                                                    </div>

                                                                    <div className='product-details'>
                                                                        <h3>
                                                                            <Link
                                                                                to={`${basenameURL}/product/${item.name.replace(
                                                                                    ' ',
                                                                                    '-'
                                                                                )}`}
                                                                                className='btn-quickview'>
                                                                                <div className='product-title'>
                                                                                    {item.name}
                                                                                </div>
                                                                            </Link>
                                                                        </h3>
                                                                        {item.promotionPrice > 0 && item.promotionPrice < item.price ? (
                                                                            <span className='price'>
                                                                                <del>
                                                                                    <span>{`${CURRENCY.B}${formatMoney(
                                                                                        item.price
                                                                                    )}`}</span>
                                                                                </del>

                                                                                <ins>
                                                                                    <span className='ammount'>{`${
                                                                                        CURRENCY.B
                                                                                        }${formatMoney(
                                                                                            item.promotionPrice
                                                                                        )}`}</span>
                                                                                </ins>
                                                                            </span>
                                                                        ) : (
                                                                            <span className='price'>
                                                                                <ins>
                                                                                    <span className='ammount'>{`${
                                                                                        CURRENCY.B
                                                                                        }${formatMoney(
                                                                                            item.price
                                                                                        )}`}</span>
                                                                                </ins>
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    }) : this.noItemShow()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {totalItems > rowsPerPage && (
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center'
                                        }}>
                                        <Pagination
                                            onChange={this.onChange}
                                            current={currentPage}
                                            pageSize={rowsPerPage}
                                            total={totalItems}
                                            showTitle={false}
                                        />
                                    </div>
                                )}
                            </div>
                        </section>
                    </>
                )}
            </div>
        );
    }
}

const mapStateToProps = ({ search, language, navigation }) => ({
    searchData: search.searchData,
    keyword: search.keyword,
    totalItems: search.totalItems,
    wording: language.wording,
    currentLanguage: language.currentLanguage,
    navbarCategory: navigation.navbarCategory,
    basenameURL: language.basenameURL
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            SearchItemFormKeyword: Actions.SearchItemFormKeyword
        },
        dispatch
    );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SearchMain));
